export const greek = {
    //buttons
    btn_login: 'Sign In',
    btn_register: 'Register',
    btn_submit: 'Submit',
    btn_done: 'Done',
    btn_next: 'Next',
    btn_save: 'Save',
    btn_edit: 'Edit',
    btn_delete: 'Delete',
    btn_back: 'Back',
    btn_addenabledevice: 'Add/Enable boxes',

    //login
    email: 'Email',
    enter_email: 'Enter email',
    password: 'Password',
    enter_password: 'Enter password',
    backup_code: "Backup Code",
    enter_verify_code: 'Enter your 6 digit code',
    enter_backup_code: 'Enter your backup code',

    forgot_password: 'Ξέχασα τον κωδικό μου',
    two_step_authentication: "Two step authentication",
    two_step_authentication_otp_desc: "To continue, please enter the 6-digit verification code sent to your authenticator application.",
    two_step_authentication_backupcode_desc: "Enter your backup code to disable two-step authentication. Your backup code is the 19 character code you received when you activated two-step authentication.",

    //home
    hello_title: 'Γειά σου',
    total_installation: "Total Install Device Activities",
    total_remove_device: "Total Remove Device Activities",
    total_swap_device: "Total Swap Device Activities",
    total_wating_active_device: "Total Wait To Activate Device Activities",
    total_reinstallation: "Total Reinstallation Activities",
    total_service_request: "Total Service Visit Activities",

    installation_device_activity: "Install Device Activities",
    remove_device_activity: "Remove Device Activities",
    swap_device_activity: "Swap Device Activities",
    waiting_add_device: "Wait To Activate Device Activities",
    reinstallation_activity: "Reinstallation Activities",
    service_visit_activity: "Service Visit Activities",

    order_summary: "Order Summary",
    COMPLETED: "Completed",
    IN_PROGRESS: "In progress",
    NEW: "New",
    DRAFT: "Draft",
    EFFECTIVE: "Effective",
    NOT_EFFECTIVE: "Not Effective",
    adding_device: "Adding Device",
    add_device: "Add Device",
    update_activity: "Update Activity",

    //table installation
    number: "Number",
    contact: "Contact",
    date: "Date",
    items: "Items",
    stage: "Stage",
    status: "Status",

    activity_name: "Name",

    in_progress: "In progress",
    pending: "Pending",

    complete_activity: "Complete Activity",
    complete_order: "Complete Order",
    btn_close: "Close",
    complete_all_activity: "Complete All Activities",

    device_removed: "Device removed",
    perform_removal:"Perform removal",
    perform_swap:"Perform swap",
    enter_removed_device: "Enter the removed device serial number",
    device_added: "Device added",
    enter_added_device: "Enter the added device serial number",

    services: "Services",
    serial_number: "Serial number",
    product: "Product",
    notes: "Notes",
    order_stage: "Order stage",
    order_status: "Order status",

    subscription_processing: "Subscriptions action is being executed",
    created_date: "Created date",
    scheduled_date: "Scheduled date",
    description: "Description",
    attach_files: "Attach files",
    type: "Type",
    order_number: "Order Number",
    total_activities: "Total Activities",
    activity_number: "Activity Number",
    scheduled_date_from: 'Scheduled date from',
    scheduled_date_to: 'Scheduled date to',
    create_password: 'Secure your account!',
    enter_your_password: 'Enter your password',
    enter_confirm_password: 'Re-enter your password',
    btn_create_password: 'Create Password',
    confirm_password: 'Confirm password',
    your_password_need: 'Your password needs to:',
    change_password: 'Change user password!',
    city: 'City',
    load_more: 'See more',
    //
    DAYS: {
        MONDAY: 'Δευτέρα',
        TUESDAY: 'Τρίτη',
        WEDNESDAY: 'Τετάρτη',
        THURSDAY: 'Πέμπτη',
        FRIDAY: 'Παρασκευή',
        SATURDAY: 'Σάββατο',
        SUNDAY: 'Κυριακή'
    }
    , SHORTDAYS: {
        MONDAY: 'Δευ',
        TUESDAY: 'Τρί',
        WEDNESDAY: 'Τετ',
        THURSDAY: 'Πέμ',
        FRIDAY: 'Παρ',
        SATURDAY: 'Σάβ',
        SUNDAY: 'Κυρ'
    }
    , SHORTMONTH: {
        JAN: 'Ιαν'
        , FEB: 'Φεβ'
        , MAR: 'Μάρ'
        , APR: 'Απρ'
        , MAY: 'Μάη'
        , JUN: 'Ιουν'
        , JUL: 'Ιουλ'
        , AUG: 'Αυγ'
        , SEP: 'Σεπ'
        , OCT: 'Οκτ'
        , NOV: 'Νοε'
        , DEC: 'Δεκ'
    }
    , MONTH: {
        JAN: 'Ιανουάριος'
        , FEB: 'Φεβρουάριος'
        , MAR: 'Μάρτιος'
        , APR: 'Απρίλιος'
        , MAY: 'Μαης'
        , JUN: 'Ιούνης'
        , JUL: 'Ιούλης'
        , AUG: 'Αύγουστος'
        , SEP: 'Σεπτέμβριος'
        , OCT: 'Οκτώβριος'
        , NOV: 'Νοέμβριος'
        , DEC: 'Δεκέμβριος'
    }

    , EXCEPTION_PROCESS: 'Το σύστημα αντιμετώπισε πρόβλημα κατά την επεξεργασία του αιτήματός σας'
    , INVALID_EMAIL_LOGIN: 'Username or password is invalid.'
    , NO_ACTIVITY_FOR_ORDER: 'No activities found for this order.'
    , UPDATE_ACTIVITY_SUCCESS: 'Successfully updated the activity.'
    , UPDATE_ACTIVITY_FAIL: 'Failed to update the activity. Please try again later.'
    , UPDATE_ACTIVITY_FROMTIME_TOTIME_INVALID: 'To time must greater than From time.'
    , COMPLETE_ACTIVITY_SUCCESS: 'Complete activity successfully.'
    , COMPLETE_ACTIVITY_FAIL: 'Complete activity unsuccessful. Please check again.'
    , CONFIRM_COMPLETE_ORDER: "Please complete your order before adding a device. We'll proceed to complete the order for you. Are you in agreement?"
    , COMPLETE_ORDER_FAILED: "Complete order unsuccessful. Please check again."
    , NO_ORDER_FOR_ACTIVITY: 'No orders are linked to this activity.'
    , ORDER_NOT_INCLUDE_PG: "We couldn't find any device associated with this order. Please try again or contact our support!"
    , ADD_DEVICE_FAILED: "Device addition failed. Please try again or contact our support!"
    , ENABLE_DEVICE_FAILED: "Device addition failed. Please try again or contact our support!"
    , ADD_DEVICE_CANNOTEXECUTEACTIONOVERDUEAMOUNTEXCEPTION: "Cannot proceed with action due to overdue account in your account. Please clear the outstanding balance to continue or contact our support for assistance."
    , ACTION_REJECTED: "Subscription action rejected"
    , REMOVE_SUCCESS: "Device has been removed successfully"
    , REMOVE_DEVICE_EXCEPTION: "Device is related with a service"
    , SWAP_SUCCESS: "Device successfully swapped"
    , NO_DEVICE_FOUND: "No devices found. Please retry or contact support for assistance"
    , DEVICE_NOT_ALLOWED: "Device Not Allowed. Please ensure that the device is authorized for use or contact support for assistance"
    , CREATE_PASSWORD_SUCCESS: 'Password is created.'
    , CREATE_PASSWORD_FAILED: 'Create password is failed.'
    , PASSWORD_NOT_MATCH: 'Passwords do not match!'
    , FORGOT_PASSWORD_SUCCESS: 'An email was sent to reset password.'
    , FORGOT_PASSWORD_FAIL: 'Can not send to email for reset password.'
    , FORGOT_EMAIL_NOT_FOUND_EXCEPTION: 'Email not found.'
    , TOO_MANY_REQUESTS: 'Too manay request. Please try again later.'
    , CHANGE_PASSWORD_SUCCESS: 'Password is changed.'
    , CANNOT_ACTIVATE_SUBSCRIPTION: 'Activate subscription not success'
    , ADD_ADDITIONALSERVICE_FAILURE: 'Add Additional service failure'
    , START_SERVICE_FAILURE: 'Start service failure'
    , UPDATE_SERVICE_FAILURE: 'Update service failure'
}
